import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "../../Components/Spinner/Spinner";
import { authorizedGet, authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import {
  config,
  errorNotify,
  successNotify,
  getValueFromLocalStorage,
  localStorageKey,
} from "../../utils/helper";
import MarriedUserList from "../../Components/MarriedUserList/MarriedUserList";
import AdvanceSearch from "../../Components/AdvanceSearch/AdvanceSearch";
import { ImCancelCircle } from "react-icons/im";
import { IoIosSearch } from "react-icons/io"; 
import { PiArrowsCounterClockwiseBold } from "react-icons/pi";


const MarriedUsers = () => {
  const ITEMS_PER_PAGE = 10;
  const [marriedUsers, setMarriedUsers] = useState([]);
  const [outSideMarriedUsers, setOutSideMarriedUsers] = useState([]);
  const [guidedUsers, setGuidedUsers] = useState([]);
  const [engagedOrFixedUsers, setEngagedOrFixedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [page, setPage] = useState(1);
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Mark as Married popup states
  const [showMarryModal, setShowMarryModal] = useState(false);
  const [selectedCouple, setSelectedCouple] = useState(null);
  const [marriedDateInput, setMarriedDateInput] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
  getAllMarriedUsers();
  setPage(1);
}, [activeTab]); 

useEffect(() => {
  setPage(1);
}, [searchQuery]);

  const toggleSearchBar = () => {
    setShowAdvanceSearch((prev) => !prev);
    setSearchQuery("");
  };

  const handleAdvanceSearch = (searchValue) => {
    setSearchQuery(searchValue.toLowerCase());
  };



  //Get All married User List
  const getAllMarriedUsers = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.getAllMarried}`,
        config,
      );
      const response = res?.data?.marriedUsers;
      console.log(response);
      if (res?.data.status) {
        setMarriedUsers(response);
        const inSideUsers = [];
        const outSideUsers = [];
        const guided = [];
        response?.forEach((item) => {
          const isGuided = item?.isGuided;
          const marriedViaVmb = item?.marriedViaVmb;

          if (isGuided) {
            guided.push(item);
          } else if (
            marriedViaVmb &&
            item?.userId?.maritalStatus === "married"
          ) {
            inSideUsers.push(item);
          } else if (
            !marriedViaVmb &&
            item?.userId?.maritalStatus === "married"
          ) {
            outSideUsers.push(item);
          }
        });
        setMarriedUsers(inSideUsers);
        setOutSideMarriedUsers(outSideUsers);
        setGuidedUsers(guided);
      }

      const engagedRes = await authorizedGet(
        `${configuration.apis.getEngagedOrFixed}`,
        config,
      );
      if (engagedRes?.data?.status) {
        setEngagedOrFixedUsers(engagedRes?.data?.users || []);
      } else {
        setEngagedOrFixedUsers([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Open the "Mark as Married" popup for the selected couple/user
  const openMarryModal = (item) => {
    setSelectedCouple(item);
    setMarriedDateInput("");
    setShowMarryModal(true);
  };

  const closeMarryModal = () => {
    setShowMarryModal(false);
    setSelectedCouple(null);
    setMarriedDateInput("");
  };

  // Confirm marriage - calls backend, refreshes list on success
  const handleMarkAsMarried = async () => {
    if (!marriedDateInput) {
      errorNotify("Please select the married date");
      return;
    }
    if (!selectedCouple?.spouse) {
      errorNotify("No spouse linked for this user. Cannot mark as married.");
      return;
    }

    const adminId = getValueFromLocalStorage(
      localStorageKey.USERDATA,
      "adminId",
    );

    setSubmitting(true);
    try {
      const res = await authorizedPost(
        `${configuration.apis.markAsMarriedFromFixed}`,
        {
          adminId,
          userId: selectedCouple?._id,
          marriedDate: marriedDateInput,
          marriedViaVmb: true,
        },
        config,
      );

      if (res?.data?.status) {
        successNotify(res?.data?.message || "Marked as married successfully");
        closeMarryModal();
        getAllMarriedUsers();
      } else {
        errorNotify(res?.data?.message || "Failed to mark as married");
      }
    } catch (error) {
      console.log(error);
      errorNotify("Unexpected error, please try again");
    } finally {
      setSubmitting(false);
    }
  };

  const tabList = [
    { name: "Married InSide", count: marriedUsers.length },
    { name: "Married OutSide", count: outSideMarriedUsers.length },
    { name: "VMB Guided", count: guidedUsers.length },
    { name: "Marriage Fixed", count: engagedOrFixedUsers.length },
  ];

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const currentData =
    activeTab === 0
      ? marriedUsers
      : activeTab === 1
        ? outSideMarriedUsers
        : activeTab === 2
          ? guidedUsers
          : engagedOrFixedUsers;
 

  const filteredData = currentData.filter((item) => {
    if (!searchQuery) return true;

    const name =
      (activeTab === 3 ? item?.name : item?.userId?.name)?.toLowerCase() ||
      "";
    const mobile =
      (activeTab === 3
        ? item?.phone
        : item?.userId?.mobile
      )?.toString() || "";

    return name.includes(searchQuery) || mobile.includes(searchQuery);
  });
 const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

 const paginatedData = filteredData.slice(
   (page - 1) * ITEMS_PER_PAGE,
   page * ITEMS_PER_PAGE,
 );
  return (
    <div className="font-jost flex w-full flex-col p-4 ">
      {loading ? (
        <div className="flex h-screen w-full items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="flex flex-col items-center gap-2 bg-bgWhite text-textGreen md:flex-row md:items-end md:justify-between">
            <ul className="flex flex-col border-b border-gray-300 md:flex-row">
              {tabList.map((list, index) => (
                <li
                  key={index}
                  className={`cursor-pointer px-4 py-2 text-center text-textGreen transition-all sm:text-xs md:text-base 
                  ${
                    activeTab === index
                      ? "border-b-2 border-textYellow font-semibold text-textYellow"
                      : "hover:bg-gray-100 hover:text-textYellow"
                  }`}
                  onClick={() => !loading && handleTabClick(index)}
                >
                  {list.name}({list.count})
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-2 ml-auto">
              {!showAdvanceSearch ? (
                <IoIosSearch
                  className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                  onClick={toggleSearchBar}
                />
              ) : (
                <div className="flex items-center gap-2">
                  <AdvanceSearch onSearchValue={handleAdvanceSearch} />
                  <ImCancelCircle
                    className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                    onClick={toggleSearchBar}
                  />
                </div>
              )}
            </div>
            <p className="text-center text-xs text-gray-400">
              Note : click user name to see full profile
            </p>
          </div>
          {paginatedData.length > 0 ? (
            <>
              {activeTab === 3 ? (
                <div className="flex flex-wrap gap-4 p-2">
                  {paginatedData.map((item) => {
                    const isEngaged = item?.maritalStatus === "engaged";
                    const hasSpouse = !!item?.spouse;
                    return (
                      <div
                        key={item._id}
                        className="flex w-full flex-col items-center justify-between gap-2 rounded-lg bg-white p-2 shadow-md md:w-[40%] xl:w-[30%]"
                      >
                        <div className="flex w-full flex-col items-center gap-1 pt-2">
                          {hasSpouse ? (
                            <div className="flex w-full items-center justify-center gap-2">
                              <Link
                                to={`/married-users/viewProfile/${item?._id}`}
                                className="text-base font-semibold text-blue-600 hover:underline"
                              >
                                {item?.name}
                              </Link>
                                        <div className="flex">
                                          <PiArrowsCounterClockwiseBold
                                            className="aria-hidden:true mt-5"
                                            style={{ fontSize: "40px", color: "#ffbb33" }}
                                          />
                                        </div>
                              <Link
                                to={`/married-users/viewProfile/${item?.spouse?._id}`}
                                className="text-base font-semibold text-blue-600 hover:underline"
                              >
                                {item?.spouse?.name}
                              </Link>
                            </div>
                          ) : (
                            <Link
                              to={`/married-users/viewProfile/${item?._id}`}
                              className="text-lg font-semibold text-blue-600 hover:underline"
                            >
                              {item?.name}
                            </Link>
                          )}
                          <span
                            className={`rounded-full px-3 py-0.5 text-xs font-semibold ${
                              isEngaged
                                ? "bg-yellow-100 text-yellow-700"
                                : "bg-green-100 text-green-700"
                            }`}
                          >
                            {isEngaged ? "Engaged" : "Marriage Fixed"}
                          </span>
                        </div>

                        <div className="flex w-full flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 text-xs text-gray-800 shadow-sm">
                          <p className="font-semibold">
                            Gender:{" "}
                            <span className="font-normal text-black">
                              {item?.gender || "NA"}
                            </span>
                          </p>
                          <p className="font-semibold">
                            Email:{" "}
                            <span className="break-all font-normal text-black">
                              {item?.primaryEmail || "NA"}
                            </span>
                          </p>
                          <p className="font-semibold">
                            Phone:{" "}
                            <span className="font-normal text-black">
                              {item?.phone || "NA"}
                            </span>
                          </p>
                          <p className="font-semibold">
                            DOB:{" "}
                            <span className="font-normal text-black">
                              {item?.dob
                                ? new Date(item.dob).toLocaleDateString(
                                    "en-CA",
                                  )
                                : "NA"}
                            </span>
                          </p>

                          {hasSpouse && (
                            <>
                              <hr className="my-1" />
                              <p className="font-semibold">
                                Spouse Gender:{" "}
                                <span className="font-normal text-black">
                                  {item?.spouse?.gender || "NA"}
                                </span>
                              </p>
                              <p className="font-semibold">
                                Spouse Email:{" "}
                                <span className="break-all font-normal text-black">
                                  {item?.spouse?.primaryEmail || "NA"}
                                </span>
                              </p>
                              <p className="font-semibold">
                                Spouse Phone:{" "}
                                <span className="font-normal text-black">
                                  {item?.spouse?.phone || "NA"}
                                </span>
                              </p>
                              <p className="font-semibold">
                                Spouse DOB:{" "}
                                <span className="font-normal text-black">
                                  {item?.spouse?.dob
                                    ? new Date(
                                        item.spouse.dob,
                                      ).toLocaleDateString("en-CA")
                                    : "NA"}
                                </span>
                              </p>
                            </>
                          )}
                        </div>

                        <button
                          onClick={() => openMarryModal(item)}
                          disabled={!hasSpouse}
                          className={`mt-1 rounded px-3 py-1 text-[11px] font-semibold text-white transition-colors ${
                            hasSpouse
                              ? "bg-textYellow hover:opacity-90"
                              : "cursor-not-allowed bg-gray-300 text-gray-500"
                          }`}
                          title={
                            !hasSpouse
                              ? "No spouse linked for this user"
                              : "Mark as Married"
                          }
                        >
                          Mark as Married
                        </button>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <MarriedUserList marriedUsers={paginatedData} />
              )}

              {totalPages > 1 && (
                <div className="mt-4 flex items-center justify-center gap-2">
                  <button
                    onClick={() => setPage((p) => Math.max(p - 1, 1))}
                    disabled={page === 1}
                    className="rounded bg-textYellow px-3 py-1 text-white disabled:opacity-80"
                  >
                    Prev
                  </button>
                  <span className="text-sm">
                    Page {page} of {totalPages}
                  </span>
                  <button
                    onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                    disabled={page === totalPages}
                    className="rounded bg-textYellow px-3 py-1 text-white disabled:opacity-80"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="flex flex-col items-center justify-center ">
              <p className="text-center">
                {activeTab === 0
                  ? "No Married Inside Users found!"
                  : activeTab === 1
                    ? "No Married Outside Users found!"
                    : activeTab === 2
                      ? "No VMB Guided Users found!"
                      : "No Engaged or Marriage Fixed Users found!"}
              </p>
            </div>
          )}
        </>
      )}

      {/* Mark as Married Popup */}
      {showMarryModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-80 rounded-lg bg-white p-4 shadow-lg">
            <h3 className="mb-3 text-center font-semibold text-textGreen">
              Mark {selectedCouple?.name}
              {selectedCouple?.spouse?.name
                ? ` & ${selectedCouple.spouse.name}`
                : ""}{" "}
              as Married
            </h3>

            {!selectedCouple?.spouse && (
              <p className="mb-2 text-xs text-red-500">
                ⚠️ No spouse linked for this user. Please link spouse first
                before marking as married.
              </p>
            )}

            <label className="mb-1 block text-xs font-semibold">
              Married Date
            </label>
            <input
              type="date"
              value={marriedDateInput}
              onChange={(e) => setMarriedDateInput(e.target.value)}
              className="mb-4 w-full rounded border px-2 py-1"
            />

            <div className="flex justify-end gap-2">
              <button
                onClick={closeMarryModal}
                className="rounded border px-3 py-1 text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleMarkAsMarried}
                disabled={submitting || !selectedCouple?.spouse}
                className="rounded bg-textYellow px-3 py-1 text-sm text-white disabled:cursor-not-allowed disabled:opacity-50"
              >
                {submitting ? "Saving..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarriedUsers;